import { render, staticRenderFns } from "./personEditLog.vue?vue&type=template&id=0f989e56&scoped=true"
import script from "./personEditLog.vue?vue&type=script&lang=js"
export * from "./personEditLog.vue?vue&type=script&lang=js"
import style0 from "./personEditLog.vue?vue&type=style&index=0&id=0f989e56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f989e56",
  null
  
)

export default component.exports